const e = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasCheck",
  viewBox: "0 0 448 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7l233.4-233.3c12.5-12.5 32.8-12.5 45.3 0z"
    }
  ]
}, a = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasChevronDown",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    }
  ]
}, t = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasChevronLeft",
  viewBox: "0 0 320 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    }
  ]
}, s = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasChevronRight",
  viewBox: "0 0 320 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    }
  ]
}, n = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasChevronUp",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    }
  ]
}, c = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasCircleCheck",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm113-303L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    }
  ]
}, l = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasCircleExclamation",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm-32 224a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
    }
  ]
}, i = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasCircleInfo",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-40-176h24v-64h-24c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    }
  ]
}, o = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasCircleQuestion",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-86.2-346.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
    }
  ]
}, m = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasCircle",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"
    }
  ]
}, w = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasSquareCheck",
  viewBox: "0 0 448 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm273 177L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    }
  ]
}, d = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasStarSharp",
  viewBox: "0 0 576 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176H56c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7l130.8 101.8-51 160c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4l129.3 100.5c8.3 6.5 19.8 6.8 28.5.7s12.3-16.9 9.1-27l-51-159.9 130.8-101.8c8.1-6.3 11.3-17 8-26.7S530.3 176 520 176H361.5L310.9 16.7z"
    }
  ]
}, h = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasTriangleExclamation",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7.2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8.2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
    }
  ]
}, r = {
  element: "svg",
  "data-testid": "icon",
  "data-name": "FasXmark",
  viewBox: "0 0 384 512",
  xmlns: "http://www.w3.org/2000/svg",
  children: [
    {
      element: "path",
      d: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"
    }
  ]
};
export {
  d as F,
  e as a,
  t as b,
  s as c,
  a as d,
  i as e,
  l as f,
  c as g,
  h,
  r as i,
  m as j,
  o as k,
  n as l,
  w as m
};
